'use strict';

/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Picks specific properties from an object based on a union of keys.
 *
 * @template T - The type of the object from which to pick properties.
 * @template K - The union of keys to pick from the object.
 * @param {T} props - The object from which to pick properties.
 * @param {K[]} selection - The array of keys to pick from the object.
 * @returns {PickFromUnion<T, K>} - An object containing the picked properties.
 */ function pickFromUnion(props, selection) {
    if (!props) return {};
    const result = selection.reduce((acc, key)=>{
        if (key in props) {
            acc[key] = props[key];
        }
        return acc;
    }, {});
    return result;
}

module.exports = pickFromUnion;
